<template lang="pug">
    header#mainHeader(:class="{'open' : isOpen}" @click.self="openMenu()")
        button.buttonMenu(@click="openMenu")
        button.up(@click="goTop()")
            img(:src="require('@images/icons/icone-arrowUp.png')")
        Menu.menu
        
</template>

<script>
import Menu from '@components/Menu/Menu.vue'

export default {
    name: "component-header",
    components: {
        Menu,
    },
    data() {
        return {
            isOpen: false
        }
    },
    methods: {
        openMenu() {
            this.isOpen = !this.isOpen
        },
        goTop() {
            window.scroll(0, 0)
        }
    },
}
</script>

<style lang="stylus" scoped src="@components/Header/Header.styl"></style>